import { CardVariantsEnum } from "../../../../../../../../utils/dataTransform/ContentQueryWidget/types";
import CardCQW from "../../../../../../../CardCQW/component";
import { CardCQWData } from "../../../../../../../CardCQW/types";
import { FeatureAttributionDataProp } from "../../types";

type CarouselCardListItemsProps = {
    items: CardCQWData[];
    featureAttributionData?: FeatureAttributionDataProp;
};

const CarouselCardListItems = ({
    items = [],
    featureAttributionData = {},
}: CarouselCardListItemsProps) => {
    if (!items.length) return null;

    const getFeatureAttribution = (
        index: number,
        featureAttributionData: FeatureAttributionDataProp | undefined
    ) => {
        if (!featureAttributionData?.instance) return undefined;
        const positionOffset = featureAttributionData.offset ?? 0;

        return {
            instance: featureAttributionData.instance,
            name: featureAttributionData.name
                ? featureAttributionData.name
                : "carousel",
            position: index + positionOffset + 1,
        };
    };
    return (
        <>
            {items.map((item, index) => (
                <li
                    className="cardContainer"
                    data-cy="cardContainer"
                    key={`${item.id}-${index}`}
                >
                    <CardCQW
                        {...item}
                        variant={CardVariantsEnum.MINIMAL}
                        featureAttribution={getFeatureAttribution(
                            index,
                            featureAttributionData
                        )}
                    />
                </li>
            ))}
        </>
    );
};

export default CarouselCardListItems;
